import React, { RefObject } from 'react';

interface AddressModalProps {
    show: boolean;
    onClose: () => void;
    onSubmit: (e: React.FormEvent) => void;
    addressError: string | null;
    searchAddress: string;
    setSearchAddress: (value: string) => void;
    modalCity: string;
    setModalCity: (value: string) => void;
    modalState: string;
    setModalState: (value: string) => void;
    modalZipCode: string;
    setModalZipCode: (value: string) => void;
    actionLoading: boolean;
    inputRef: RefObject<HTMLInputElement | null>;
}

const AddressModal: React.FC<AddressModalProps> = ({
    show, onClose, onSubmit, addressError, searchAddress, setSearchAddress,
    modalCity, setModalCity, modalState, setModalState, modalZipCode, setModalZipCode,
    actionLoading, inputRef,
}) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-xs z-[200] flex items-center justify-center p-4">
            <div className="bg-white rounded-3xl p-6 max-w-md w-full shadow-2xl space-y-4 animate-in zoom-in-95 duration-150 text-left">
                <h3 className="text-xl font-bold text-green-900 text-center" style={{ fontFamily: 'Comic Sans MS, Comic Sans, cursive' }}>Enter Your Home Address 🏠</h3>
                {addressError && <div className="p-2.5 bg-red-50 text-red-600 rounded-xl border text-xs font-semibold">⚠️ {addressError}</div>}

                <form onSubmit={onSubmit} className="space-y-3.5">
                    <div className="relative">
                        <label className="block text-xs font-bold text-gray-500 mb-1">Search Address</label>
                        <div className="flex items-center border border-gray-200 bg-gray-50 p-2.5 rounded-xl">
                            <input ref={inputRef} type="text" value={searchAddress} onChange={(e) => setSearchAddress(e.target.value)} placeholder="Search Address" className="w-full bg-transparent outline-none text-sm text-black font-medium" />
                        </div>
                    </div>
                    <div className="grid grid-cols-3 gap-2">
                        <div className="col-span-1">
                            <label className="block text-[11px] font-bold text-gray-500 mb-1">City</label>
                            <input type="text" value={modalCity} onChange={(e) => setModalCity(e.target.value)} required placeholder="City" className="w-full border border-gray-200 text-sm px-2.5 py-2 rounded-xl text-black bg-white" />
                        </div>
                        <div className="col-span-1">
                            <label className="block text-[11px] font-bold text-gray-500 mb-1">State</label>
                            <input type="text" value={modalState} onChange={(e) => setModalState(e.target.value)} required placeholder="State" className="w-full border border-gray-200 text-sm px-2.5 py-2 rounded-xl text-black bg-white" maxLength={2} />
                        </div>
                        <div className="col-span-1">
                            <label className="block text-[11px] font-bold text-gray-500 mb-1">ZIP Code</label>
                            <input type="text" value={modalZipCode} onChange={(e) => setModalZipCode(e.target.value)} required placeholder="ZIP code" className="w-full border border-gray-200 text-sm px-2.5 py-2 rounded-xl text-black bg-white" maxLength={5} />
                        </div>
                    </div>
                    <div className="flex gap-2 pt-2">
                        <button type="button" onClick={onClose} className="w-1/3 border border-gray-200 bg-white font-bold py-2 rounded-xl text-xs text-gray-500 hover:bg-gray-50">Cancel</button>
                        <button type="submit" disabled={actionLoading} className="w-2/3 bg-green-600 hover:bg-green-700 text-white font-black py-2 rounded-xl text-xs flex justify-center items-center">
                            {actionLoading ? "Saving..." : "Submit"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddressModal;
